<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Způsob vypořádání záboru</label>
    <div class="input">
      <gmt-select
        [data]="inputData"
        field="occupationSolutionType"
        [optionItems]="occupationSolutionTypeOptions"
        (changed)="updated()"
      ></gmt-select>
    </div>
  </div>
  <div class="column-100" *ngIf="inputData.occupationSolutionType?.key === 'CANCELLED'">
    <label class="required">Důvod zrušení</label>
    <textarea [(ngModel)]="inputData.finalSolutionReasonCancellation" (ngModelChange)="updated()" rows="5"></textarea>
  </div>
</fieldset>
